import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./ForgotPasswordPage.css";

// 🔧 Base API robuste (prod/dev) : VITE/REACT_APP → nettoyée ; sinon même domaine
const RAW =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
  process.env.VITE_API_URL ||
  process.env.REACT_APP_API_URL ||
  "";

const API_BASE =
  RAW
    ? RAW.replace(/\/+$/, "").replace(/\/api$/i, "")
    : (typeof window !== "undefined" && window.location.origin) || "";

function ForgotPasswordPage() {
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [fromSettings, setFromSettings] = useState(false);
  const [msg, setMsg] = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(false);

  const emailRegex = /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/;

  useEffect(() => {
    let didSet = false;

    if (location?.state?.email) {
      setEmail(location.state.email);
      setFromSettings(true);
      didSet = true;
    }

    if (!didSet) {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      if (userId) {
        (async () => {
          try {
            const res = await fetch(`${API_BASE}/api/users/${userId}`, {
              headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
              },
              credentials: "include",
            });
            const data = await res.json().catch(() => ({}));
            if (data?.email) {
              setEmail(data.email);
              setFromSettings(true);
            }
          } catch {
            // ignore
          }
        })();
      }
    }
  }, [location?.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!emailRegex.test(email)) {
      setMsg({ text: "Adresse email invalide.", type: "error" });
      return;
    }

    setLoading(true);
    setMsg({ text: "", type: "" });

    try {
      const response = await fetch(`${API_BASE}/api/auth/forgot_password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        setMsg({
          text: "Un email de réinitialisation a été envoyé si l’adresse existe.",
          type: "success",
        });
      } else {
        setMsg({
          text: data?.error || "Une erreur est survenue. Essayez plus tard.",
          type: "error",
        });
      }
    } catch {
      setMsg({ text: "Erreur serveur, réessayez plus tard.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <h2>{fromSettings ? "Changer de mot de passe" : "Mot de passe oublié"}</h2>

      <form className="forgot-password-form" onSubmit={handleSubmit}>
        <label htmlFor="forgot-email">
          {fromSettings ? "Email de votre compte" : "Adresse email"}
        </label>
        <input
          id="forgot-email"
          type="email"
          value={email}
          placeholder={fromSettings ? "Adresse de votre compte" : "Votre adresse email"}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={loading || fromSettings}
          readOnly={fromSettings}
        />

        <button type="submit" disabled={loading}>
          {loading ? "Envoi en cours..." : "Envoyer"}
        </button>

        {msg.text ? <div className={`forgot-password-message ${msg.type}`}>{msg.text}</div> : null}
      </form>
    </div>
  );
}

export default ForgotPasswordPage;

